(function () {
  const BLOG_SECTION_SUFFIXES = [
    '__featured_blog_F7XmHR',
    '__featured_blog_cxAMnF',
    '__featured_blog_ARWg4g',
    '__featured_blog_eq46ge',
  ];

  const WEEKDAY_INDEX = {
    Sun: 0,
    Mon: 1,
    Tue: 2,
    Wed: 3,
    Thu: 4,
    Fri: 5,
    Sat: 6,
  };

  function getTorontoDateParts(date) {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Toronto',
      weekday: 'short',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).formatToParts(date);

    return parts.reduce((value, part) => {
      if (part.type !== 'literal') {
        value[part.type] = part.value;
      }

      return value;
    }, {});
  }

  function getTuesdayWeekSeed(date) {
    const parts = getTorontoDateParts(date);
    const weekday = WEEKDAY_INDEX[parts.weekday] ?? 0;
    const daysSinceTuesday = (weekday - WEEKDAY_INDEX.Tue + 7) % 7;
    const today = Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day));
    const weekStart = today - daysSinceTuesday * 24 * 60 * 60 * 1000;

    return Math.floor(weekStart / (7 * 24 * 60 * 60 * 1000));
  }

  function seededRandom(seed) {
    let value = seed + 0x6d2b79f5;

    return function () {
      value |= 0;
      value = (value + 0x6d2b79f5) | 0;

      let result = Math.imul(value ^ (value >>> 15), 1 | value);
      result = (result + Math.imul(result ^ (result >>> 7), 61 | result)) ^ result;

      return ((result ^ (result >>> 14)) >>> 0) / 4294967296;
    };
  }

  function shuffle(items, seed) {
    const random = seededRandom(seed);
    const shuffled = items.slice();

    for (let index = shuffled.length - 1; index > 0; index -= 1) {
      const swapIndex = Math.floor(random() * (index + 1));
      const current = shuffled[index];
      shuffled[index] = shuffled[swapIndex];
      shuffled[swapIndex] = current;
    }

    return shuffled;
  }

  function applyBlogSpacing(section, index, total) {
    const inner = section.querySelector('.blog > .page-width-desktop');

    if (!inner) return;

    inner.style.setProperty('padding-top', index === 0 ? '72px' : '24px', 'important');
    inner.style.setProperty('padding-left', '60px', 'important');
    inner.style.setProperty('padding-right', '60px', 'important');
    inner.style.setProperty('padding-bottom', index === total - 1 ? '36px' : '12px', 'important');
  }

  function rotateBlogSections() {
    const sections = BLOG_SECTION_SUFFIXES
      .map((suffix) => document.querySelector(`[id$="${suffix}"]`))
      .filter(Boolean);

    if (sections.length < 2) return;

    const parent = sections[0].parentElement;

    if (!parent || sections.some((section) => section.parentElement !== parent)) return;

    const seed = getTuesdayWeekSeed(new Date());
    const orderedSections = shuffle(sections, seed);
    const marker = document.createComment('weekly-blog-rotation-anchor');

    parent.insertBefore(marker, sections[0]);
    orderedSections.forEach((section, index) => {
      applyBlogSpacing(section, index, orderedSections.length);
      parent.insertBefore(section, marker);
    });
    parent.removeChild(marker);
  }

  function initializeEditorialUpdates() {
    rotateBlogSections();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeEditorialUpdates, { once: true });
  } else {
    initializeEditorialUpdates();
  }
})();
